// removed by extract-text-webpack-plugin
module.exports = {"product-wrapper":"Product-module-product-wrapper-29QCd","productWrapper":"Product-module-product-wrapper-29QCd","delaer-locator-mobile":"Product-module-delaer-locator-mobile-UIF97","delaerLocatorMobile":"Product-module-delaer-locator-mobile-UIF97","manufacture-wrapper":"Product-module-manufacture-wrapper-2Uc_2","manufactureWrapper":"Product-module-manufacture-wrapper-2Uc_2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/Product.module.scss
// module id = 1277
// module chunks = 0